/* eslint-disable react/jsx-props-no-spreading */
/**
 * @fileoverview Molecule: wraps inbox messages + composer with react-dropzone (drag images only, no click).
 * @module ChatMessagesDropzoneMC
 * @category Component - Molecule
 */
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import useInboxChatMessagesDropzoneUI from '../../../hooks/inbox/ui/useInboxChatMessagesDropzoneUI';

/**
 * @param {Object} props
 * @param {boolean} props.canDrop - Whether drag-and-drop should accept files (chat open + permissions).
 * @param {function(File[]): void} [props.onDropAcceptedFiles] - Optional custom handler instead of sharingInformationService.
 * @param {React.ReactNode} props.children - Typically AreaChatWindowMC and InboxComposerMC.
 */
const ChatMessagesDropzoneMC = memo(({
  canDrop,
  onDropAcceptedFiles,
  children
}) => {
  const { t } = useTranslation('InboxMC');
  const {
    getRootProps,
    getInputProps,
    showDragOverlay,
    handlePasteCapture
  } = useInboxChatMessagesDropzoneUI({
    canDrop,
    onDropAcceptedFiles
  });

  return (
    <div
      {...getRootProps({
        className: 'tw-relative tw-flex tw-flex-col tw-flex-1 tw-h-0 tw-min-h-0 tw-min-w-0',
        onPasteCapture: handlePasteCapture
      })}
    >
      <input {...getInputProps()} />
      {showDragOverlay && (
        <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-z-10 tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-black/40">
          <p className="tw-text-lg tw-font-medium tw-text-white tw-px-4 tw-text-center">
            {t('chatDropzone.dropImagesHere')}
          </p>
        </div>
      )}
      {children}
    </div>
  );
});

ChatMessagesDropzoneMC.displayName = 'ChatMessagesDropzoneMC';

export default ChatMessagesDropzoneMC;
